<template>
	<div v-if="input.type == 'msg'">
		<div class="alert alert-dismissible" :class="input.alert_type">
			<button type="button" class="close" data-dismiss="alert">×</button>
			<h4>
				<i
					v-if="input.alert_type == 'alert-info'"
					class="icon fa fa-info"
				></i>
				<i
					v-if="input.alert_type == 'alert-danger'"
					class="icon fa fa-ban"
				></i>
				<i
					v-if="input.alert_type == 'alert-warning'"
					class="icon fa fa-warning"
				></i>
				<i
					v-if="input.alert_type == 'alert-success'"
					class="icon fa fa-check"
				></i>
				{{ input.label }}
			</h4>
			{{ input.placeholder }}
		</div>
	</div>
</template>
<script>
	export default {
		name: 'ChAlert',
		props: ['data'],
		computed: {
			input() {
				return this.data;
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/models/create-form/inputs/ch-alert.vue